<template>
  <div class="library-top">
    <el-breadcrumb separator-class="el-icon-d-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="item in breadList" :to="item.path">{{item.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: "Breadcrumb",
    props: {
      breadList: Array
    }
  }
</script>

<style lang="less" scoped>
  .library-top {
    width: 100%;
    height: 100px;
    padding: 48px 0px 32px 62px;
    .el-breadcrumb__item {
      font-size: 20px;
      font-weight: bold;
    }
    /deep/ .is-link:hover {
      color: #654719;
    }
  }
</style>
